import styles from './PackGalleryCaption.module.scss'

/**
 * Gallery caption row — Toile's port of narcis's/ovid's own `packs/PackGalleryCaption.tsx` (pack
 * page canon convergence). A single fixed sentence above the labelled sample rows; no per-cell
 * caption, no heading — canon's galleryProof carries no `<h2>` and no per-image visible text, only
 * this one line plus the row labels. Toile's per-cell recipe text (subject/style/palette/framing),
 * dropped from here, still reaches search engines through the `<img alt>` on each sample
 * (`PackGrid.tsx`) and the route's `ImageGallery` JSON-LD, both unchanged by this component's own
 * removal.
 */
export function PackGalleryCaption() {
    return (
        <p className={styles.caption} role="note">
            every sample — three subjects, three styles ↓
        </p>
    )
}
